import { isNative, platform } from '~/plugins/native/capacitor'

export default function ({ store }) {
  if (isNative) {
    const { Keyboard } = require('@capacitor/keyboard')

    // Don't hide the "done/close" keyboard bar on iOS
    if (platform === 'ios') {
      Keyboard.setAccessoryBarVisible({ isVisible: true })
    }

    // Sometimes the keyboard covers elements, we may need to react to it being visible
    Keyboard.addListener('keyboardWillShow', () => {
      store.commit('device/setNativeKeyboardVisible', true)
    })

    Keyboard.addListener('keyboardDidHide', () => {
      store.commit('device/setNativeKeyboardVisible', false)
    })
  }
}
